export * from '@primeuix/themes/nora/knob';
export { default } from '@primeuix/themes/nora/knob';
